import Chat from "./../../services/Chat";
import Auth from "./../../services/authService";
import { firebaseApp } from "./../../services/firebaseService";

export const SendAlert = (selected_chat_user) => {
    let { uniquecode: txnID, app_picture, phone, firstname, lastname } = Auth.getUserDetail();
    const { uniquecode: rcvID } = selected_chat_user;
    const room_id = Chat.room_id(txnID, rcvID);
    let TxnExists = Chat.if_room_exists(txnID);
    let RcvExists = Chat.if_room_exists(rcvID);
    let IndividualStructure = { createdBy: txnID, last_message: "", updated_at: firebaseApp.database.ServerValue.TIMESTAMP, last_message_type: "", profile: "", last_message_sender: "", sender_name: "", roomName: room_id, phone: "", type: "individual", favourite: false };
    Promise.all([TxnExists, RcvExists]).then(value => {
        value.map((val, key) => {
            let __parentId = key === 0 ? txnID : rcvID;
            let displayName = key === 0 ? selected_chat_user.name : `${firstname} ${lastname}`;
            let recipient = key === 0 ? rcvID : txnID;
            let profile = key === 0 ? selected_chat_user.app_picture : app_picture
            phone = key === 0 ? selected_chat_user.phone : phone;
            let __instanceToSend = { ...IndividualStructure, displayName, profile, phone, recipient, last_seen: false, meet: true };
            if (val === false) {
                Chat.update_ref_with_children(`/Users/${__parentId}/${room_id}/`, __instanceToSend).then(() => {
                    if (key === 1 && selected_chat_user.message) {
                        handleSend(selected_chat_user, room_id);
                    }
                });
            } else {
                Chat.if_room_exists_return_value(key === 0 ? txnID : rcvID).then(values => {
                    if (!Object.keys(values).includes(room_id)) {
                        Chat.update_ref_with_children(`/Users/${__parentId}/${room_id}/`, __instanceToSend).then(() => {
                            if (key === 1 && selected_chat_user.message) {
                                handleSend(selected_chat_user, room_id);
                            }
                        });
                    }else{
                        if (key === 1 && selected_chat_user.message) {
                            handleSend(selected_chat_user, room_id);
                        }
                    }
                })
            }
        });
    });
}

export const handleSend = (selected_chat_user, room_id) => {
    let type = "meet";
    const { uniquecode: rcv_uniquecode, name: rcv_name, message, meet_type, media } = selected_chat_user;
    const { firstname: txn_firstname, lastname: txn_lastname, uniquecode: txn_uniquecode } = Auth.getUserDetail();

    let dataToSend = { message, date: firebaseApp.database.ServerValue.TIMESTAMP, from: txn_uniquecode, type: meet_type, media, to: rcv_uniquecode, from_name: `${txn_firstname} ${txn_lastname}`, to_name: rcv_name };
    Chat.update_message_data(room_id, dataToSend);
    Chat.if_room_exists_return_value(txn_uniquecode).then(value => {
        Chat.update_room_data(txn_uniquecode, { ...value, [room_id]: { ...value[room_id], last_message: message, updated_at: firebaseApp.database.ServerValue.TIMESTAMP, last_message_type: type, last_message_sender: txn_uniquecode, last_seen: true } });
    });
    Chat.if_room_exists_return_value(rcv_uniquecode).then(value => {
        Chat.update_room_data(rcv_uniquecode, { ...value, [room_id]: { ...value[room_id], last_message: message, updated_at: firebaseApp.database.ServerValue.TIMESTAMP, last_message_type: type, last_message_sender: txn_uniquecode, last_seen: false } });
    });
};